import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { ResultSection } from '../common/sections/ResultSection';
import { PageHeader } from '../common/PageHeader';
import BrandUtils from '../../utils/BrandUtils';
import ProductUtils from '../../utils/ProductUtils';
import BrowserUtils from '../../utils/BrowserUtils';

/**
 * @todo
 * This component could benefit from refactoring to improve it's quality
 */
class ContactBankPage extends Component {
  componentDidMount() {
    BrowserUtils.setViewPort(1);
  }

  render() {
    return (
      <div className="internet-banking result-page-wrapper contact-bank-page-wrapper container-fluid">
        <Helmet title={this.props.content.contactBankPageHeader} />
        <PageHeader
          visible={BrandUtils.isAbleToDisplay('result-pages-header')}
          title={
            this.props.content.landingPageTitle +
            ProductUtils.getName(this.props.data.productCode)
          }
          content={this.props.content}
        />
        <div className="result-page white-board contact-bank-page" role="main">
          <div className="row text-center">
            <div className="col-xs-12">
              <ResultSection
                imgSrc={BrandUtils.getResultImage(
                  'contact-bank-page-with-image',
                  'bank-illustration.png'
                )}
                imgAlt="Contact Bank"
                title={this.props.content.contactBankPageTitle}
              >
                <p>{this.props.content.contactBankPageExplanation}</p>
              </ResultSection>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactBankPage.propTypes = {
  data: PropTypes.object,
  validations: PropTypes.object,
  content: PropTypes.object,
};

export { ContactBankPage };
